import axios from 'axios';
import {
  NotificationItem,
  NotificationStats,
  TriggerRule,
  CreateNotificationPayload,
  CreateTriggerPayload
} from './types';

const API_BASE = 'https://tbl.zerdegroup.kz/api/notifications';

export const fetchNotificationsList = async (params: {
  page: number;
  limit: number;
  status?: string;
  targetType?: string;
  search?: string;
}) => {
  const res = await axios.get(`${API_BASE}/admin/list`, { params });
  return res.data;
};

export const fetchPharmaciesList = async (): Promise<string[]> => {
  const res = await axios.get(`${API_BASE}/admin/pharmacies`);
  return res.data?.pharmacies || [];
};

export const createNotificationApi = async (payload: CreateNotificationPayload) => {
  const res = await axios.post(`${API_BASE}/admin/create`, payload);
  return res.data;
};

export const toggleNotificationActiveApi = async (id: number, isActive: boolean) => {
  const res = await axios.patch(`${API_BASE}/admin/${id}/toggle`, { isActive });
  return res.data;
};

export const deleteNotificationApi = async (id: number) => {
  const res = await axios.delete(`${API_BASE}/admin/${id}`);
  return res.data;
};

export const fetchNotificationStatsApi = async (id: number): Promise<NotificationStats> => {
  const res = await axios.get(`${API_BASE}/admin/${id}/stats`);
  return res.data;
};

export const fetchTriggersList = async (): Promise<TriggerRule[]> => {
  const res = await axios.get(`${API_BASE}/admin/triggers`);
  return res.data?.triggers || [];
};

export const createTriggerApi = async (payload: CreateTriggerPayload) => {
  const res = await axios.post(`${API_BASE}/admin/triggers`, payload);
  return res.data;
};

export const toggleTriggerApi = async (id: number, isEnabled: boolean) => {
  const res = await axios.patch(`${API_BASE}/admin/triggers/${id}/toggle`, { isEnabled });
  return res.data;
};

export const deleteTriggerApi = async (id: number) => {
  const res = await axios.delete(`${API_BASE}/admin/triggers/${id}`);
  return res.data;
};

export const runTriggerApi = async (id: number, date?: string) => {
  const res = await axios.post(`${API_BASE}/admin/triggers/${id}/run`, { date });
  return res.data;
};
